import styled, {
  css,
} from 'styled-components';
import {
  transparentize,
} from 'polished';
import {
  Flex,
  SVG,
} from 'web-styled';

type LabelType = {
  color?: string;
  weight: string | number;
};
export const Label = styled.label<LabelType>`
  color: ${props => (props.theme.colors[props.color] || props.color || '#888')};
  font-size: 13px;
  font-weight: normal;
  font-weight: ${({ weight }) => weight || 400};
  display: flex;
  justify-content: flex-start;
`;

export const Error = styled.span`
  color: ${props => props.theme.colors.danger};
  font-size: 13px;
  font-weight: normal;
  font-weight: 400;
  align-self: flex-end;
  margin-left: 5px;
`;

export const Keystroke = styled.span`
  color: ${props => props.theme.colors.primary};
  font-size: 13px;
  font-weight: normal;
  font-weight: 400;
  align-self: flex-end;
  margin-left: auto;
  padding: 1px 3px;
  border-color: ${props => props.theme.colors.primary};
  border-width: 1px;
  border-style: solid;
  border-radius: 3px;
`;

export const Radio = styled.input`
  margin: 0;
  margin-left: 1px;
  background: red;
`;

export const DatePickerContainer = styled(Flex).attrs(() => ({
  width: '100%',
}))`
  & > div {
    width: 100%;
  }
`;

export const SelectContainer = styled(Flex).attrs(() => ({
  width: '100%',
}))`
  & > div {
    width: 100%;
  }
`;

export const DatePickerWrapper = styled.div`
  width: 100%;

  & > div,
  & > div > .react-datepicker__input-container {
    width: 100%;
  }

  .react-datepicker-popper {
    min-width: 320px;
  }

  .react-datepicker__time-container,
  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
    width: 76px;
  }

  .react-datepicker__navigation {
    outline: none;
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range,
  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected,
  .react-datepicker__month-text--selected,
  .react-datepicker__month-text--in-selecting-range,
  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected,
  .react-datepicker__month-text--in-range {
    background-color: ${props => props.theme.colors.primary} !important;

    &:hover {
      background-color: ${props => props.theme.colors.primary} !important;
    }
  }
`;

export const DatePickerInput = styled.input`
  display: block;
  width: 100%;
  height: calc(2.25rem + 9px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  color: ${props => props.theme.colors.inputColor};
  background-color: #eee;
  background-clip: padding-box;
  border-width: 1px;
  border-style: solid;
  border-color: #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;
  cursor: pointer;
  outline: none;
  box-sizing: border-box;
`;

export const RightIcon = styled.div`
  position: absolute;
  top: ${props => props.top}px;
  right: 10px;
  cursor: pointer;
`;

export const PlusCircle = styled(SVG.PlusCircle).attrs(
  props => ({
    width: 14,
    height: 14,
    stroke: props.theme.colors.primary,
  }),
)`
`;

export const Tag = styled(Flex).attrs({
  align: 'center',
  spacing: 5,
  padding: '5px 15px',
})`
  color: #fff;
  font-size: 15px;
  white-space: nowrap;
  border-radius: 25px;
  margin-bottom: 6px;
  background-color: ${props => props.theme.colors.tag};
`;

const cardElementStyles = css`
  display: grid;
  color: #333;
  align-items: center;
  padding: 6px 12px;
  font-size: 14px;
  width: 100%;
  height: calc(2.25rem + 9px);
  line-height: 1.5;
  border-radius: 0.25rem;
  border-width: 1px;
  border-style: solid;
  box-sizing: border-box;
`;

const getFocusShadowColor = (props) => {
  if (props.hasError) return 'rgba(255, 86, 10, 0.25)';
  return transparentize(0.75, props.theme.colors.primary);
};

type ElementType = {
  hasError: boolean;
};
export const FormElementContainer = styled(Flex).attrs({
  column: true,
  spacing: 5,
})<ElementType>`
  width: 100%;
  position: relative;

  .card-element {
    ${cardElementStyles};
    border-color: ${(props) => (props.hasError ? props.theme.colors.danger : '#ced4da')};

    &.StripeElement--focus {
      outline: 0;
      box-shadow: 0 0 0 0.2rem ${props => getFocusShadowColor(props)};
      border-color: ${(props) => (props.hasError ? props.theme.colors.danger : props.theme.colors.primary)};
      background-color: #fff;
    }
  }
`;

export const TimeInputWraper = styled(Flex).attrs({
  align: 'center',
})`
  color: #808084;
  position: relative;
  border-radius: 0.25rem;
  border: 1px solid ${props => (props.hasError ? props.theme.colors.danger : '#ced4da')};

  & > input {
    text-align: center;
    border: none;
    padding: 0.375rem;
    height: calc(2.25rem + 7px);
  }
`;
